import React,{useState,useEffect} from "react";
import './classes/ScoutAgentAthleteExport.css';
import { configData } from "../config";
import Loading from './Loading';
import Select from 'react-dropdown-select';
import { Helmet } from 'react-helmet';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DataGrid } from '@mui/x-data-grid';
 import { Link } from '@mui/material';
 import { format } from "date-fns";

const ScoutAgentAthleteExport = ()=>{
      const initialForm = () => {
      const params = new URLSearchParams(window.location.search);
      const defaultForm = {     
        start_date: '',
        end_date: '',
        pay_start_date: '',
        pay_end_date: '',
        start_date_obj: null,
        end_date_obj: null,
        pay_start_date_obj: null,
        pay_end_date_obj: null,
        roles: 'all',
        user_status:'all',
        agent_sports:'',
        scout_sports:'',
        athlete_sports:'',
        view:'',
        action:''
        };    
       //  normal dates
        const queryStart = params.get("start_date");
        const queryEnd = params.get("end_date");

        const startObj =
            queryStart
            ? new Date(queryStart.replace(/-/g, "/") + " 00:00:00")
            : null;

        const endObj =
            queryEnd
            ? new Date(queryEnd.replace(/-/g, "/") + " 00:00:00")
            : null;

        //  payment dates
        const queryPaydayStart = params.get("pay_start_date");
        const queryPaydayEnd = params.get("pay_end_date");

        const paydayStartObj =
            queryPaydayStart
            ? new Date(queryPaydayStart.replace(/-/g, "/") + " 00:00:00")
            : null;

        const paydayEndObj =
            queryPaydayEnd
            ? new Date(queryPaydayEnd.replace(/-/g, "/") + " 00:00:00")
            : null;

        const queryView = params.get("view") || ''; 

        return {
            ...defaultForm,
            roles: params.get("roles") || defaultForm.roles,
            user_status: params.get("user_status") || defaultForm.user_status,

            // ---------- SPORTS ----------
            agent_sports: params.get("agent_sports") || '',
            scout_sports: params.get("scout_sports") || '',
            athlete_sports: params.get("athlete_sports") || '',


            //  normal dates
            start_date: startObj ? queryStart : '',
            start_date_obj: startObj,

            end_date: endObj ? queryEnd : '',
            end_date_obj: endObj,

            //  payment dates
            pay_start_date: paydayStartObj ? queryPaydayStart : '',
            pay_start_date_obj: paydayStartObj,

            pay_end_date: paydayEndObj ? queryPaydayEnd : '',
            pay_end_date_obj: paydayEndObj,

            view: queryView,
            action:''
        };
        };
     const [appliedFormData, setAppliedFormData] = useState(initialForm());     
      const [formData, setFormData] = useState(initialForm);
      const [submittedData, setSubmittedData] = useState(null);
       const [isSubmitted, setIsSubmitted] = useState(false); 
      const [isLoading, setIsLoading] = useState(true);  
       const [sportsOptions, setSportList] = useState({}); 
       const [totalamount, setTotalAmount] = useState(0); 
       const [recuramount, setRecurAmount] = useState(0); 
      const app_url = configData.APP_URL;
        useEffect(() => {
           Promise.all([       
            getsportslist()
          
          ]).then(() => {
     
            setIsLoading(false);
          })
        }, []);
  

    
  async function getsportslist() {
    
         try {
            const response = await fetch(
                app_url+'agentscoutathletereport/getsportslist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
            
                setSportList(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
        
  }
    const columns = [
    {
    field: 'first_name',
    headerName: 'First Name',   
    flex:1,     
    // minWidth:82,
    cellClassName:'first_name_column',headerClassName:'first_name_header',
  },
  {
    field: 'last_name',
    headerName: 'Last Name',      
    flex:1,   
    // minWidth:77,
    cellClassName:'last_name_column',headerClassName:'last_name_header',
  },
 
    {
    field: 'email',
    headerName: 'E-mail',
    flex:1,  
    // minWidth:247,
    cellClassName:'email_column',headerClassName:'email_header', 
     renderCell: (params) => (
    <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.email}
      </Link>
  ),
    
  },
  {
    field: 'salesperson',
    headerName: 'Salesperson',      
    flex:1,
    // minWidth:67,
    sortable: false,
    cellClassName:'salesperson_column',headerClassName:'salesperson_header',
  },
    
  {
    field: 'roles',
    headerName: 'Roles',   
    flex:1,   
    // minWidth:94,
    cellClassName:'roles_column',headerClassName:'roles_header',
  },
  {
    field: 'country',
    headerName: 'Country',   
    flex:1,    
    // minWidth:109,
    cellClassName:'country_column',headerClassName:'country_header',
  },  

  {
    field: 'primary_phone',
    headerName: 'Primary Phone',   
    flex:1,    
    // minWidth:62,
    cellClassName:'primary_phone_column',headerClassName:'primary_phone_header',
  },
  {
    field: 'initiated_date',
    headerName: 'Initiated Date',   
    flex:1,    
    // minWidth:62,
    sortable: false,
    cellClassName:'initiated_date_column',headerClassName:'initiated_date_header',
  },
  {
    field: 'sports',
    headerName: 'Sports',   
    flex:1,    
    // minWidth:82,
    sortable: false,
    cellClassName:'sports_column',headerClassName:'sports_header',
  },
  {
    field: 'show_on_frontend',
    headerName: 'On Frontend?',   
    flex:1,
    // minWidth:82,
    sortable: false,
    cellClassName:'on_frontend_column',headerClassName:'on_frontend_header',
  },
  {
    field: 'expiration_date',
    headerName: 'Next/Last Payment Date',   
    flex:1,
    // minWidth:82,
    sortable: false,
    cellClassName:'payment_date_column',headerClassName:'payment_date_header',
  },
  {
    field: 'expiration_status',
    headerName: 'Payment Status',   
    flex:1,
    // minWidth:82,
    sortable: false,
    cellClassName:'payment_status_column',headerClassName:'payment_status_header',
  },
  {
    field: 'initiation_amount',
    headerName: 'Initiation Amount',   
    flex:1,
    // minWidth:82,
    sortable: false,
    cellClassName:'initiation_amount_column',headerClassName:'initiation_amount_header',
  },
  {
    field: 'monthly_amount',
    headerName: 'Monthly Amount',   
    flex:1,   
    // minWidth:82,
    sortable: false,
    cellClassName:'monthly_amount_column',headerClassName:'monthly_amount_header',
  },
];

 /*main-table*/
const [rows, setRows] = React.useState([]);
  const [rowCount, setRowCount] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
  const [sortModel, setSortModel] = React.useState([]);
  const [filterModel, setFilterModel] = React.useState({ items: [] });
  const [formErrors, setFormErrors] =useState({});
  
//   const handleChange = (e) => {
//   const { name, value } = e.target;
//   setFormData(prev => ({
//     ...prev,
//     [name]: value
//   }));
// };
const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData(prev => {
    if (name === "roles") {
      return {
        ...prev,
        [name]: value,
        agent_sports: '',
        scout_sports: '',
        athlete_sports: '',
      };
    }

    return {
      ...prev,
      [name]: value
    };
  });
};
// const handleCreatedDateChange = (date) => {
//   const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
//   setFormData(prev => ({ ...prev, start_date: formattedDate }));
// };
// const handleCreatedEndDateChange = (date) => {
//   const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
//   setFormData(prev => ({ ...prev, end_date: formattedDate }));
// };
// const handlePaymentDateChange = (date, name) => {
//   const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
//   setFormData(prev => ({ ...prev, [name]: formattedDate }));
// };
const handleDateChange = (date, field) => {
  setFormData(prev => ({
    ...prev,
    [`${field}_obj`]: date,                       // for DatePicker
    [field]: date ? format(date, 'yyyy-MM-dd') : '' // for backend
  }));
};

  const validateDates = (formData) => {
    let errors = {};  

    if (formData.start_date && formData.end_date) {
      if (formData.end_date < formData.start_date) {
        errors.end_date = "Start date can't over end date.";
      }
    }
    if (formData.end_date && !formData.start_date ) {
        errors.start_date = "Start date is required.";
    }
    if (formData.start_date && !formData.end_date) {
        errors.end_date = "End date is required.";
    }
       if (formData.pay_start_date && formData.pay_end_date) {
      if (formData.pay_end_date < formData.pay_start_date) {
        errors.pay_end_date = "Payment Start date can't over payment end date.";
      }
    }

    if (!formData.pay_start_date && formData.pay_end_date) {
        errors.pay_start_date = "Payment start date is required.";
    }

    if (formData.pay_start_date && !formData.pay_end_date) {
        errors.pay_end_date = "Payment end date is required.";
    }


    return errors;
  };
   
     React.useEffect(() => {
   if(submittedData) {
      const fetchData = async () => {
       // Simulate API call to your server
      // In a real application, replace this with your actual fetch logic
       try {
         setIsLoading(true);
       const response = await fetch(app_url+'agentscoutathletereport/getlist', {
       method: 'POST',
        headers: { 'Content-Type': 'application/json' },
                 body: JSON.stringify({
           page: paginationModel.page,
           pageSize: paginationModel.pageSize,
           sortModel,
           filterModel,
			 //  formData:formData				   
         //  formData:appliedFormData
            formData: {
                ...appliedFormData,
                action: isSubmitted ? 'submit' : ''
            }
         }),
       });
       const data = await response.json();
       console.log(data.data.rows);
       setRows(data.data.rows);
       setRowCount(data.data.totalRowCount); // Server should return totalRowCount
       setTotalAmount(data.data.totalamount);
       setRecurAmount(data.data.totalrecuramount);
       }  catch (error) {
            console.error('Error fetching data:', error);           
          } finally {
             setIsLoading(false); // Set loading to false after fetch completes (success or error)
             if (isSubmitted) {
                    setIsSubmitted(false);
                }
           }
          
     };
    

     fetchData();
   }
       }, [paginationModel, sortModel, filterModel, appliedFormData]); // Re-fetch data when these change 

    const submitFormData = async (data) => {
        setSubmittedData(data);
        setAppliedFormData(data);
        setIsSubmitted(false);
    };
    
  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault(); // stop page reload
     const errors = validateDates(formData);

    if (Object.keys(errors).length > 0) {
      console.log("Validation errors:", errors);
      setFormErrors(errors); 
      return;
    }
    setFormErrors({});
    setSubmittedData(formData);
    // Reset pagination state
                setPaginationModel({
                 page: 0,
                    pageSize: 50,
                 });
      setAppliedFormData({ ...formData });
       setIsSubmitted(true);
      // try {
      //   setIsLoading(true);
      //  const response = await fetch(app_url+'agentscoutathletereport/getlist', {
      //    method: 'POST',
      //    headers: { 'Content-Type': 'application/json' },
      //    body: JSON.stringify({
      //      page: 0,
      //      pageSize: 50,
      //      sortModel,
      //      filterModel,
      //      formData:formData
      //    }),
      // });
      //  const data = await response.json();
      //  console.log(data.data.rows);
      //  setRows(data.data.rows);
      //  setRowCount(data.data.totalRowCount); // Server should return totalRowCount
      //  setTotalAmount(data.data.totalamount);
      //  setRecurAmount(data.data.totalrecuramount);
      // }  catch (error) {
      //       console.error('Error fetching data:', error);
      //      } finally {
      //       setIsLoading(false); // Set loading to false after fetch completes (success or error)
      //      }
  

    console.log("Form submitted:", formData);
    

  };
  const handleExport = async (e) => {
    e.preventDefault(); // stop page reload
     const errors = validateDates(formData);

    if (Object.keys(errors).length > 0) {
      console.log("Validation errors:", errors);
      setFormErrors(errors); 
      return;
    }
    setFormErrors({});
   
     try {
        setIsLoading(true);
      const response = await fetch(app_url+'agentscoutathletereport/getexport', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          
          // formData:formData
          formData:submittedData
        }),
      });
      const data = await response.json();
      const csvUrl = data.data.csvUrl;
      const urlParts = csvUrl.split('/');
        const fileName = urlParts[urlParts.length - 1];
                const link = document.createElement('a');
                link.href = csvUrl;
                // link.setAttribute('download', 'data.csv');
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
      
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }


  };
    useEffect(() => {
          const params = new URLSearchParams(window.location.search);
  
          if ([...params.keys()].length > 0) {
          const init = initialForm();
  
          setFormData(init);
  
          submitFormData(init);              
          }
      }, []);
   // Define sports options for each role dynamically
  /* const sportsOptions = {
    agent_sports: [
      "Action Sports", "Baseball", "Basketball", "Boxing", "Cricket", "Football (American)",
      "Golf", "Hockey", "Martial Arts", "Motor Sports", "Olympic", "Rugby", "Soccer", "Weightlifting"
    ],
    scout_sports: [
      "Action Sports", "Baseball", "Basketball", "Boxing", "Cricket", "Football (American)",
      "Golf", "Hockey", "Martial Arts", "Motor Sports", "Olympic", "Rugby", "Soccer", "Weightlifting"
    ],
    athlete_sports: [
      { value: 45, label: "Action Sports" }, { value: 2, label: "Baseball" },
      { value: 3, label: "Basketball" }, { value: 7, label: "Boxing" },
      { value: 8, label: "Cricket" }, { value: 9, label: "Curling" },
      { value: 42, label: "Extreme Sports" }, { value: 1, label: "Football (American)" },
      { value: 5, label: "Golf" }, { value: 6, label: "Hockey" }, { value: 39, label: "Motor Sports" },
      { value: 44, label: "Olympic" }, { value: 41, label: "Other" }, { value: 16, label: "Polo" },
      { value: 18, label: "Rodeo" }, { value: 46, label: "Rugby" }, { value: 4, label: "Soccer" },
      { value: 30, label: "Tennis" }, { value: 31, label: "Track and Field" }
    ]
  }; */

  // Helper to render a dynamic select for sports
  const renderSportsSelect = (name, options) => (
    <div>
      {name.replace('_', ' ')}:<br />
      <select
        className="form-select"
        id={name}
        name={name}
        value={formData[name]}
        onChange={handleChange}
      >
        <option value="">-Select-</option>
        {options.map(opt => {
          if (typeof opt === 'string') {
            return <option key={opt} value={opt.toLowerCase().replace(/\s+/g, '_')}>{opt}</option>;
          }
          return <option key={opt.value} value={opt.value}>{opt.label}</option>;
        })}
      </select>
    </div>
  );


    return(
           <>
            {isLoading ? (
              <Loading />
            ) : (
        <div id="main scout-agent-athlete-export"  className="scout-agent-athlete-export-main">
                <Helmet>
                    <title>
                        Agent Athlete Scout Report
                    </title>
                </Helmet>
            <div className="left"></div>
            <div className="center left-center">
              <h1>Agent Athlete Scout Report</h1>
                <div className="scout-agent-athlete-export-container">               
                 <form >              
                      <div className="full_width">
                              <div className="left_column">
                                <div>
                                  <label>Created Start Date:<br />
                                    <DatePicker
                                      selected={formData.start_date_obj}
                                      onChange={(date) => handleDateChange(date, 'start_date')}
                                      id="start_date"
                                      name="start_date"
                                    />
                                  </label>
                                   {formErrors.start_date && (
                    <div className="error">{formErrors.start_date}</div>
                  )} 
                                </div>
                                <div>
                                  <label>Created End Date:<br />
                                    <DatePicker
                                      selected={formData.end_date_obj}
                                      onChange={(date) => handleDateChange(date, 'end_date')}
                                      id="end_date"
                                      name="end_date"
                                    />
                                  </label>
                                   {formErrors.end_date && (
                    <div className="error">{formErrors.end_date}</div>
                  )} 
                                </div>
                                <div>
                                  Role:<br />
                                  <small>Select a specific role if you want to filter by sport.</small><br />
                                  <select
                                    className="form-select"
                                    id="roles"
                                    name="roles"
                                    value={formData.roles}
                                    onChange={handleChange}
                                  >
                                    <option value="all">All Users</option>
                                    <option value="6">Agent</option>
                                    <option value="5">Scout</option>
                                    <option value="11">Athlete</option>
                                  </select>
                                  &nbsp;
                                  <select
                                    className="form-select"
                                    id="user_status"
                                    name="user_status"
                                    value={formData.user_status}
                                    onChange={handleChange}
                                  >
                                    <option value="all">All</option>
                                    <option value="Active">Active</option>
                                    <option value="Inactive">Inactive</option>
                                  </select>
                                </div>
                              </div>

                              <div className="right_column">
                                <div>
                                  <label>Payment Start Date:<br />
                                    <DatePicker
                                      selected={formData.pay_start_date_obj}
                                      onChange={(date) => handleDateChange(date, 'pay_start_date')}
                                      id="pay_start_date"
                                      name="pay_start_date"
                                    />
                                  </label>
                              {formErrors.pay_start_date && (
                    <div className="error">{formErrors.pay_start_date}</div>
                  )} 
                                </div>
                                <div>
                                  <label>Payment End Date:<br />
                                    <DatePicker
                                      selected={formData.pay_end_date_obj}
                                      onChange={(date) => handleDateChange(date, 'pay_end_date')}
                                      id="pay_end_date"
                                      name="pay_end_date"
                                    />
                                  </label>
                                {formErrors.pay_end_date && (
                    <div className="error">{formErrors.pay_end_date}</div>
                  )} 
                                </div>
                                <div>
                                  {formData.roles === "6" && renderSportsSelect("agent_sports", sportsOptions.agent_sports)}
                                  {formData.roles === "5" && renderSportsSelect("scout_sports", sportsOptions.scout_sports)}
                                  {formData.roles === "11" && renderSportsSelect("athlete_sports", sportsOptions.athlete_sports)}
                                </div>
                              </div>
                            </div>                       

                
                          <input type="submit" value="Submit" className="form-submit"  onClick={handleSubmit}/>&nbsp; &nbsp;
                           <input type="button" value="Export" className="form-submit"  onClick={handleExport} disabled={!submittedData} />                         
                    
                 </form>                 
                 {submittedData && (
                  <>                
                     
                 
                    <div id="total_apps"><strong>Total Monthly Amount:</strong> {recuramount} </div>
                   <div id="total_apps"><strong>Total Initiation Amount:</strong> {totalamount}</div>
                    <div id="total_apps"><strong>Total Apps: {rowCount}</strong></div>
               
                   <div className="scout-agent-athlete-export-table">
                                           <table className="">
                                                <div style={{ width: '100%' }}>
                                                <DataGrid
                                                rows={rows}
                                                columns={columns}
                                                rowCount={rowCount}
                                                paginationMode="server"
                                                sortingMode="server"
                                                filterMode="server"
                                                paginationModel={paginationModel}
                                                onPaginationModelChange={setPaginationModel}
                                                sortModel={sortModel}
                                                onSortModelChange={setSortModel}
                                                filterModel={filterModel}
                                                onFilterModelChange={setFilterModel}
                                                pageSizeOptions={[5, 10, 25,50]}
                                                getRowId={() => crypto.randomUUID()}
                                                getRowHeight={() => 'auto'}
                                                disableColumnFilter 
                                                //disableColumnResize={true}
                                            />
                                               </div>
                                            </table>
                                            </div>
                                                           
                                            </>
                 )}
</div>
            </div>
            <div className="right">
                 
            </div>
        </div>
               )}
    </>
    );
};
export default ScoutAgentAthleteExport;